import { render } from "./AuthView.vue?vue&type=template&id=19e1a223&scoped=true&ts=true"
import script from "./AuthView.vue?vue&type=script&lang=ts"
export * from "./AuthView.vue?vue&type=script&lang=ts"

import "./AuthView.vue?vue&type=style&index=0&id=19e1a223&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19e1a223"]])

export default __exports__